module.exports = __webpack_public_path__ + "assets/img/enbtn.2f8232ae.png";